import type { ApiOrgId } from 'api/types/ApiTypedId';
import { Button } from 'components/Button/Button';
import { useSaveListing } from 'hooks/useSaveListing';
import type { ApiOrgType } from 'modules/listing/api/org/types/ApiOrgType';

type Props = {
  orgId: ApiOrgId;
  orgName: string;
  orgType: ApiOrgType;
};

export function SaveOrgMenuItem({ orgId, orgName, orgType }: Props) {
  const { listingIsSaved, canSave, saveListing, unsaveListing } =
    useSaveListing({
      listingId: orgId,
      listingType: 'ORG',
      listingName: orgName,
      orgId,
      orgType,
    });

  const saveText = getText('Save Organization');
  const unsaveText = getText('Unsave Organization');

  const onClick = (saveOrUnsaveListing: () => void) => {
    if (canSave) saveOrUnsaveListing();
  };

  return (
    <Button
      onClick={() => onClick(listingIsSaved ? unsaveListing : saveListing)}
      data-qa-id={`${listingIsSaved ? 'unsave' : 'save'}-org`}
      variant="link-grey"
      iconPosition="left"
      icon={{ type: 'normalized', name: 'star-outline' }}
      size="small"
      type="button"
    >
      {listingIsSaved ? unsaveText : saveText}
    </Button>
  );
}
